document.addEventListener("DOMContentLoaded", function () { 

  // ==================  load more collection page start RB
  
  $(document).on('click','.paginate_load_button', function(e){
    e.preventDefault(); 
    let nextUrl = $(this).attr("href");
     $(this).addClass('active-url-holder');
    $(this).parents('.pagination-loader-with-btn').addClass('active-paginate_load_button');
    $.ajax({
      type: 'GET',
      url: nextUrl,
      dataType: "html",
      beforeSend: function() {
        $('.loader-img').show();
      $('.active-url-holder').hide();
      },
      success: function(data) {
        $('.active-paginate_load_button').remove();
        console.log("success");
        var page2data =$(data).find('.chanel-collection-product_main').html();
        $('.chanel-collection-product_main').append(page2data);
      },
    });

  });
  
// ===========================load more collection page end RB
 
// ============================Tags collection page start RB
  $('.Collapsible__Button').click(function(){
    $(this).parents('.Collapsible').find('.Collapsible__Inner').slideToggle();
  });
  
 
  $(document).on('click','.custom-tags-li input[type=checkbox]', function(e){
  var all_tag = [];
    $(this).parents('.custom-tags-li').toggleClass('is-selected');
    $('.is-selected').each(function(){
    var tag_name = $(this).data('tag');
      if(tag_name == null){
      }else{
        all_tag.push(tag_name);
      }
    });
     var new_tags = all_tag.join('+');
    var url = $('.hidden-url-input').data('url');
 var new_tagurl = url+new_tags;
    console.log(new_tagurl);
    
    jQuery.ajax({
      type: 'GET',
      url: new_tagurl,
      dataType: 'html',
      success: function(data){ 
        console.log("success!");
        var apenddata = $(data).find('.chanel-collection-product_main').html();
        $('.chanel-collection-product_main').html(apenddata); 
      },
      error: function() {
        console.log("fail");						
      }
    });
  
  });
  
//  ======================== tags collection page end RB
  var color_length = $('.product-inner-div-content').length;
  if(color_length > 0){
    var new_length = color_length;
    $('.count-appen-span').html(new_length);
  }

  $('.main_tottle_button_div .toggle_btn_icon').click(function(){
    $('.toggle_top').toggle();
    $('.toggle_bottom').toggle();
    $('.hide_toggle_divs').slideToggle();
  });
  
  
  $('.chanel-collection-page-template-filter h5').click(function(){
    if($( window ).width()<771){
      $('.inner-filter-content').slideToggle();
    }
  });
  
  
  $(document).on("change",".dropdown-variable select",function(){
var curr= $(this).val();
$(".swatch-element input[value='"+curr+"']").trigger("click");
});
  var checked= $(".swatch-element input:checked").val();
  $(".dropdown-variable select").val(checked);
  
});

